type PathValue<T, P extends string> = P extends `${infer K}.${infer Rest}`
  ? K extends keyof T
    ? PathValue<T[K], Rest>
    : never
  : P extends keyof T
    ? T[P]
    : never

export function getNestedValue<T, P extends string>(
  obj: T,
  key: P
): PathValue<T, P> | unknown[] {
  const parts = key.split(".")
  let current: any = obj

  for (const part of parts) {
    if (current === undefined || current === null) return []
    current = current[part]
  }

  return current ?? []
}
